export default {
	home: "Écran principal",
	settings: "Le réglage"
}
